<template>
  <ActionPopover
    :show="show"
    :style="style"
    class="action-popover-form z-20"
    @hide="$emit('hide')"
  >
    <header v-if="title" class="action-popover-form__header">
      {{ title }}
    </header>
    <slot />
    <div class="action-popover-form__footer">
      <ElButton type="text" icon="el-icon-right" @click="back">
        {{ $t('ADVERTISEMENT.POPOVER_ACTION_FORM.BACK_TO_MENU') }}
      </ElButton>
      <ElButton :loading="isLoading" type="primary" size="medium" @click="save">
        {{ $t('SAVE') }}
      </ElButton>
    </div>
  </ActionPopover>
</template>

<script>
import ActionPopover from './ActionPopover';

export default {
  name: 'ActionPopoverForm',
  components: {
    ActionPopover,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: '340px',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    style() {
      return {
        width: this.width,
      };
    },
  },
  methods: {
    back() {
      this.$emit('back');
    },
    save() {
      this.$emit('save');
    },
  },
};
</script>

<style lang="scss">
.action-popover-form {
  padding: $global-padding;

  &__header {
    font-size: rem-calc(13px);
    font-weight: bold;
    margin-bottom: $global-margin * 1.5;
  }

  &__footer {
    border-top: 1px dashed #dfdfdf;
    padding-top: $global-padding * 1.25;

    display: flex;
    justify-content: space-between;
  }
}
</style>
